import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { VisitingHoursFieldsListResource } from 'app/models/VisitingHoursFieldsListResource';
import { VisitingHoursFieldsResource } from 'app/models/VisitingHoursFieldsResource';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { forkJoin } from 'rxjs';
import { TranslateService } from '@ngx-translate/core';
import { NotificationsService } from 'angular2-notifications';
import { UtilsService } from 'app/services/utils.service';
import { VisitingHoursDepartmentResource } from 'app/models/VisitingHoursDepartmentResource';

@Component({
  selector: 'vbn-add-edit-field',
  templateUrl: './add-edit-field.component.html',
  styleUrls: ['./add-edit-field.component.scss']
})
export class AddEditFieldComponent implements OnInit {

  fieldForm: FormGroup;
  selected_language: string;
  field: VisitingHoursFieldsResource;
  addressParams: any;
  fieldRid: any;
  departmentRid: any;
  saveErrors: boolean = false;
  errorMessage: any;
  userEmail: string;




  constructor(private fb: FormBuilder,
    private activatedRoute: ActivatedRoute,
    private translate: TranslateService,
    private _notificationService: NotificationsService,
    private service: UtilsService,
    private router: Router    ) { 
    this.selected_language = "ro";
    this.field = new VisitingHoursFieldsResource();
  }


  ngOnInit() {
    this.userEmail = this.service.currentUserEmail;

    this.activatedRoute.params.subscribe((params: Params) => {
      this.addressParams = JSON.parse(atob(params['json']));
      this.fieldRid = this.addressParams.fieldRid;
      this.departmentRid = this.addressParams.departmentRid;
     /*  console.log("--->>> Department ID = ", this.departmentRid);
      console.log("--->>> field ID = ", this.fieldRid); */
      (this.fieldRid !== "null") && (this.getField());
    });
    
    
   // ============= Form init ============
    this.fieldForm = this.fb.group({
      fieldRo: ['', [ Validators.required] ],
      valueRo: ['', [ Validators.required] ],
      fieldEn: [''],
      valueEn: [''],
      fieldFr: [''],
      valueFr: [''],
      fieldDe: [''],
      valueDe: ['']
    });
  }

  getField(){
    this.service.get(`/admin/visitingHours/fields/getOne/${this.fieldRid}`)
      .subscribe( 
        response => {
          this.field = response;
        },
        error => this.errorMessage = <any>error
      )
  }

  edit() {
    this.saveErrors = true;
    if (!this.fieldForm.valid) {
      forkJoin(
        this.translate.get('Mising fields'),
        this.translate.get('Please fill out the fields on all languages!')
      ).subscribe((res) => {
        this._notificationService.create(res[0], res[1], 'error')
      });
      return;
    }

    this.field.visitingHoursDepartmentResource = new VisitingHoursDepartmentResource();
    this.field.visitingHoursDepartmentResource.rid = this.departmentRid;
    this.service.add('/admin/visitingHours/fields/edit', this.field)
      .subscribe(
        response => {
          this.field = response;
          if(this.fieldRid) {
            forkJoin(
              this.translate.get('Success'),
              this.translate.get('Field successfully edited!')
            ).subscribe((res) => {
              this._notificationService.create(res[0], res[1], 'success')
            });
          } else {
            forkJoin(
              this.translate.get('Success'),
              this.translate.get('Field successfully created!')
            ).subscribe((res) => {
              this._notificationService.create(res[0], res[1], 'success')
            });
          }
          window.scrollTo(500, 0);
          this.router.navigate(['/edit-visiting-department/' + btoa('{ "departmentRid" : "' + this.departmentRid + '"}')]);
        },
        error => this.errorMessage = <any>error);
  }

  back(){
    window.scrollTo(500, 0);
    this.router.navigate(['/edit-visiting-department/' + btoa('{ "departmentRid" : "' + this.departmentRid + '"}')]);

  }
}
